import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-del",
  "use": "icon-del-usage",
  "viewBox": "0 0 15 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 15\" id=\"icon-del\">\n  <defs>\n    <style>\n      #icon-del .cls-1 {\n        fill: #777;\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-del_删除\" class=\"cls-1\" d=\"M2213.5,1716H2210v-0.5a1.5,1.5,0,0,0-1.5-1.5h-4a1.5,1.5,0,0,0-1.5,1.5v0.5h-3.5a0.5,0.5,0,0,0,0,1h1.5v10.5a1.5,1.5,0,0,0,1.5,1.5h8a1.5,1.5,0,0,0,1.5-1.5V1717h1.5A0.5,0.5,0,0,0,2213.5,1716Zm-9.5-.5a0.5,0.5,0,0,1,.5-0.5h4a0.5,0.5,0,0,1,.5.5v0.5h-5v-0.5Zm7,12a0.5,0.5,0,0,1-.5.5h-8a0.5,0.5,0,0,1-.5-0.5V1717h9v10.5Zm-7.5-8.5a0.5,0.5,0,0,0-.5.5v6a0.5,0.5,0,0,0,1,0v-6A0.5,0.5,0,0,0,2203.5,1719Zm3,0a0.5,0.5,0,0,0-.5.5v6a0.5,0.5,0,0,0,1,0v-6A0.5,0.5,0,0,0,2206.5,1719Zm3,0a0.5,0.5,0,0,0-.5.5v6a0.5,0.5,0,0,0,1,0v-6A0.5,0.5,0,0,0,2209.5,1719Z\" transform=\"translate(-2199 -1714)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/svg/del.svg
// module id = HFQa
// module chunks = 41